export enum SignInErrorMessages {
    invalidCredentials = 'INVALID_CREDENTIALS',
    accountLocked = 'USER_LOCKED',
    accountDisabled = 'USER_DISABLED',
    sessionExpired = 'SESSION_EXPIRED',
}
